import { useTranslation } from 'react-i18next';

// eslint-disable-next-line no-restricted-imports
import { Card, Icon, Label } from 'semantic-ui-react';

// Import style
import cardStyles from '../Shared/CardHelpers/CardStyles.module.scss';

const icons = {
  ios: 'apple',
  android: 'android',
};

const DeviceCard = ({ device, onClick }) => {
  const { t } = useTranslation();

  return (
    <Card
      className="shadow"
      key={device.id}
      onClick={onClick}
      header={<Card.Header className={cardStyles.textTruncate}>{device.name}</Card.Header>}
      meta={
        <div>
          <div className={cardStyles.textTruncate}>
            {t('devices.credentials.usernameLabel')}: <code>{device.email}</code>
          </div>
          <div className={cardStyles.textTruncate}>
            {t('common.passwordLabel')}: <code>{device.password}</code>
          </div>
        </div>
      }
      extra={
        <div>
          <Icon size="big" name={icons[device.type]} />
          <Label
            content={device.enabled ? t('devices.card.status.enabled') : t('devices.card.status.disabled')}
            color={device.enabled ? 'green' : 'red'}
          />
        </div>
      }
    />
  );
};

export default DeviceCard;
